import React from 'react';

/**
 * MDT-style stat tile with vertical accent stripe + big bold number.
 */
export function NxTickerTile({
  label,
  value,
  hint,
  tone = 'blue',
  icon,
  active = false,
  onClick,
  ...rest
}) {
  const toneCls = tone !== 'blue' ? `nx-stat--${tone}` : '';
  const ledTone = tone !== 'blue' ? `nx-led--${tone}` : 'nx-led--blue';
  return (
    <button
      type="button"
      onClick={onClick}
      className={`nx-stat ${toneCls} ${active ? 'nx-stat--active' : ''}`}
      {...rest}
    >
      <div className="nx-stat-label">
        {icon && <span style={{ color: 'var(--nx-ink-dim)', display: 'inline-flex' }}>{icon}</span>}
        <span>{label}</span>
      </div>
      <div className={`nx-stat-value ${ledTone}`} style={{ marginTop: 2 }}>{value}</div>
      {hint && <span className="nx-stat-hint">{hint}</span>}
    </button>
  );
}
